import React, { useState } from 'react';
import { withFormik, FormikProps } from 'formik';
import { IntlShape, injectIntl } from 'react-intl';
import { Grid, Box, CircularProgress, makeStyles } from '@material-ui/core';
import { Info } from 'react-feather';
import Modal from 'components/Modal';
import InputField from 'components/InputField';
import validationSchema from 'containers/PasswordRecoveryPages/InsertIdentifiant/validationSchema';
import messages from 'containers/PasswordRecoveryPages/InsertIdentifiant/messages';
import { translate } from 'helpers/intl';
import { StyledOrangeButton } from 'containers/PasswordRecoveryPages/InsertIdentifiant/styles';
import { OrangeButton } from 'components/Button';
import {
  formStyle,
  SizedLongBody,
  StyledBodyText,
} from 'containers/LoginPage/styles';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';

const useStyles = makeStyles({
  ...formStyle,
});

const InsertIdentifiantForm = (
  props: { loader?: boolean; errorMessage?: string } & FormikProps<FormValues>,
) => {
  const [open, setOpen] = useState(false);
  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    loader,
  } = props;

  const classes = useStyles();

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleErrorMessage = () => {
    GATracking.event(
      EVENT_CATEGORIES.RECOVERY_PASSWORD,
      EVENT_ACTION.ERROR,
      "Chargement du bloc d'erreur",
    );
    return translate({ ...messages.loginError }, props);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box paddingY={2} paddingX={[2, 4, 8]}>
        <Grid item>
          <InputField
            name="identifiant"
            placeholder={translate({ ...messages.identifiant }, props)}
            value={values.identifiant}
            error={
              props.errorMessage
                ? translate({ ...messages.loginError }, props)
                : errors.identifiant
            }
            helperText={
              props.errorMessage ? handleErrorMessage() : errors.identifiant
            }
            endAdornment={
              <Info
                className={classes.infoIcon}
                onClick={() => handleOpenModal()}
              />
            }
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </Grid>

        <Grid>
          <GaClickHOC
            category={EVENT_CATEGORIES.RECOVERY_PASSWORD}
            label="valider"
          >
            <StyledOrangeButton type="submit" variant="contained">
              {loader ? (
                <CircularProgress data-testid="loader" size={20} />
              ) : (
                <React.Fragment>
                  {translate({ ...messages.valid }, props)}
                </React.Fragment>
              )}
            </StyledOrangeButton>
          </GaClickHOC>
        </Grid>
      </Box>
      <Modal
        open={open}
        handleOpen={handleOpenModal}
        handleClose={handleCloseModal}
        header={
          <SizedLongBody weight="500" color="#04336B">
            {translate(messages.modalHeader, props)}
          </SizedLongBody>
        }
        content={
          <StyledBodyText>
            {translate(messages.modalContent, props)}
          </StyledBodyText>
        }
        footer={
          <Grid container justify="flex-end">
            <Grid item>
              {' '}
              <OrangeButton variant="contained" onClick={handleCloseModal}>
                {translate(messages.close, props)}
              </OrangeButton>
            </Grid>
          </Grid>
        }
      ></Modal>
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  loader?: boolean;
  onSubmit: Function;
  errorMessage?: string;
}

interface FormValues {
  identifiant: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      identifiant: '',
    };
  },

  validationSchema,

  handleSubmit: ({ identifiant }, { props }) => {
    props.onSubmit({ login: identifiant });
  },
})(InsertIdentifiantForm);

export default injectIntl(Form);
